import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import history from './History';

class Terms extends Component {
  render() {
    return (
      <div>
        <div className="docs-title">
          <h1>Megadigm<span className="trademark">&reg;</span> Terms and Conditions</h1>
        </div>
        <div className="docs-content"><b>Last Updated:</b> 03/08/2026</div>
        <div className="docs-content">
          <p>
            These Terms & Conditions ("Agreement") govern the access to and use of Megadigm<span className="trademark">&reg;</span>’s (“Provider”) real-time data streaming and
            analytics platform (“Service”) by the company signing up for the service (“Customer”). By using the Service, Customer agrees to be bound by these terms.
          </p>
          <h2 id="svcnaccess">The Service and Access</h2>
          <h3 id="license">License</h3>
          <p>
            Provider grants Customer a non-exclusive, non-transferable, revocable license to access the Service for internal business purposes during the subscription term.
          </p>
          <h3 id="datastreaming">Data Streaming</h3>
          <p>
            The Service provides real-time processing of data provided by the Customer ("Customer Data"). Provider does not guarantee uninterrupted, real-time latency due to 
            internet connectivity, but will make reasonable efforts to maintain performance.
          </p>
          <h3 id="usagelimit">Usage Limitations</h3>
          <p>
            Customer shall not: (a) reverse engineer, decompile, or attempt to extract source code or raw data; (b) use the service to build a competitive product; 
            or (c) transmit malicious code or viruses.
          </p>
          
          <h2 id="dataprivacy">Customer Data and Privacy</h2>
          <h3 id="ownership">Ownership</h3>
          <p>
            Customer retains all rights, title, and interest in and to all Customer Data. Provider acquires no rights to Customer Data other than the right to process it to
            provide the Service.
          </p>
          <h3 id="dataproc">Data Processing</h3>
          <p>
            Customer is solely responsible for the accuracy, quality, and legality of Customer Data.
          </p>
          <h3 id="aggdata">Analytics & Aggregated Data</h3>
          <p>
            Provider may gather data regarding system performance and user behavior ("Usage Data"). Provider may use this data for improvement, diagnostic, or security purposes.
          </p>
          
          <h2 id="subandpay">Subscriptions and Payment</h2>
          <h3 id="fees">Fees</h3>
          <p>
            Customer agrees to pay all fees outlined in the order form or pricing page.
          </p>
          <h3 id="billing">Billing</h3>
          <p>
            Subscriptions are billed monthly in advance. Unpaid accounts may be suspended after a 30-day grace period.
          </p>
          <h3 id="usagefees">Usage-Based Fees</h3>
          <p>
            If the service is usage-based (e.g., volume of data streamed), excess usage beyond the contracted tier will be charged at the current list price.
          </p>
          
          <h2 id="secresp">Security and Responsibilities</h2>
          <h3 id="creds">Customer Credentials</h3>
          <p>
            Customer is responsible for maintaining the confidentiality of user logins and all activities under its account.
          </p>
          <h3 id="secprec">Security Precautions</h3>
          <p>
            While Provider implements industry-standard encryption and security for data in transit and at rest, Customer is responsible for ensuring their network complies with specifications.
          </p>
          <h3 id="breachnote">Breach Notification</h3>
          <p>
            Customer must notify Provider immediately of any unauthorized access to their account.
          </p>
          
          <h2 id="sls">Service Levels and Support</h2>
          <h3 id="uptime">Uptime</h3>
          <p>
            Provider aims for 99.9% uptime, excluding planned maintenance.
          </p>
          <h3 id="support">Support</h3>
          <p>
            Support will be provided via <Link to={{ pathname: '/requestform/generalinquiry',  state: { from: history.location.pathname } }}><b>message center</b></Link>.
            Expect delayed response outside business hours (9 AM – 5 PM PST).
          </p>
          
          <h2 id="intprop">Intellectual Property</h2>
          <h3 id="platformowner">Platform Ownership</h3>
          <p>
            Megadigm<span className="trademark">&reg;</span> retains all rights, title, and interest in the Service, software, and any improvements or modifications made thereto.
          </p>

          <h2 id="limitliab">Limitation of Liability and Warranty</h2>
          <ul className="docs-list">
            <li><b>"AS IS":</b> THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." PROVIDER DISCLAIMS ANY WARRANTIES, INCLUDING MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.</li>
            <li><b>Liability Cap:</b> TO THE MAXIMUM EXTENT PERMITTED BY LAW, PROVIDER’S TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT PAID BY CUSTOMER IN THE 6 MONTHS PRECEDING THE CLAIM.</li>
            <li><b>Indirect Damages:</b> Provider is not liable for indirect, consequential, or punitive damages, including loss of data, profits, or business interruption.</li>
          </ul>

          <h2 id="termterm">Term and Termination</h2>
          <h3 id="term4cause">Termination for Cause</h3>
          <p>
            Either party may terminate this agreement if the other party materially breaches the agreement and fails to cure such breach within 30 days of notice.
          </p>
          <h3 id="dataretention">Data Retention</h3>
          <p>
            Upon termination, Customer has 30 days to export their data. Thereafter, Provider may delete all Customer Data.
          </p>

          <h2 id="governinglaw">Governing Law</h2>
          <p>
            This Agreement is governed by the laws of the State of Washington, without regard to its conflict of laws principles.
          </p>
        </div>
      </div>
    );
  }
}

export default Terms;